<template>
  <div class="container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <img src="../assets/Story-Icon-Hero.svg" alt="Centivo" class="logo" />
    <FirstTimeLoginForm @loggingIn="isLoading = $event"/>
  </div>
</template>

<script>
import FirstTimeLoginForm from '../components/first-time-login-form.vue'

export default {
  name: 'firstTimeLogin',
  components: {
    FirstTimeLoginForm
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
.login {
  width: 25%;
  align-content: center;
  align-self: center;
  display: inline-block;
}

.logo {
  display: block;
  margin: auto;
  width: 48px;
  padding-top: 10%;
  margin-bottom: 32px;
}
</style>
